module.exports = __webpack_public_path__ + "img/lemonade-img.eb542d24.png";